module.exports = __webpack_public_path__ + "static/media/own-teapot-icon.5552fa04.svg";